import metricsOverviewQuery, {
	type PerformanceOverviewMainQuery,
} from '@jira/admin-pages__performance/src/__generated__/PerformanceOverviewMainQuery.graphql';
import type { PreloadedQuery } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const metricsOverviewPageResource: RouteResource<
	PreloadedQuery<PerformanceOverviewMainQuery, Record<string, unknown>>
> = createRelayResource<PerformanceOverviewMainQuery>({
	type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
	getQuery: (_, { tenantContext }) => ({
		parameters: metricsOverviewQuery,
		variables: {
			cloudId: tenantContext.cloudId,
			schemaMigrationEnabled: fg('site_optimiser_schema_migration'),
			projectLevelReportingEnabled: fg('slt1-682-fe-project-level-reporting-so'),
		},
		options: {
			fetchPolicy: 'network-only',
		},
	}),
});
